// src/services/CartService.js

const CART_KEY = "cart";

export const getCart = () => {
    try {
        const cart = JSON.parse(localStorage.getItem(CART_KEY)) || [];
        return cart;
    } catch (err) {
        console.error("Error reading cart from localStorage", err);
        return [];
    }
};

export const saveCart = (cart) => {
    try {
        localStorage.setItem(CART_KEY, JSON.stringify(cart));
    } catch (err) {
        console.error("Error saving cart to localStorage", err);
    }
};

export const addToCart = (product, qty = 1) => {

    const cart = getCart();
    const index = cart.findIndex(
        (item) =>
            item.slug === product.slug &&
            item.color === product.color &&
            item.size === product.size
    );

    if (index >= 0) {
        cart[index].qty = Math.min(cart[index].qty + qty, product.stock || 99);
    } else {
        cart.push({ ...product, qty });
    }

    saveCart(cart);
    return cart;
};

export const updateCartItem = (slug, qty, color = null, size = null) => {
    const cart = getCart();

    const index = cart.findIndex((item) => {
        const matchSlug = item.slug === slug;
        const matchColor = color ? item.color === color : !item.color;
        const matchSize = size ? item.size === size : !item.size;

        return matchSlug && matchColor && matchSize;
    });

    if (index >= 0) {
        cart[index].qty = qty;
        saveCart(cart);
    }

    return cart;
};

export const removeCartItem = (slug, color = null, size = null) => {

    const cart = getCart().filter((item) => {
        const matchSlug = item.slug === slug;
        const matchColor = color ? item.color === color : !item.color;
        const matchSize = size ? item.size === size : !item.size;

        return !(matchSlug && matchColor && matchSize);
    });

    saveCart(cart);
    return cart;
};

export const clearCart = () => {
    localStorage.removeItem(CART_KEY);
};
